import type { ReactNode } from 'react';

// Les icones du prototype, relevees trait pour trait. Elles sont dessinees en SVG plutot
// qu'importees d'une bibliotheque : ce sont une dizaine de traces, et une dependance
// d'icones pesait plus lourd que le fichier que vous lisez.

interface PropsIcone {
  taille?: number;
  couleur?: string;
  epaisseur?: number;
}

function Trace({
  taille = 24,
  couleur = 'currentColor',
  epaisseur = 1.9,
  enfants,
}: PropsIcone & { enfants: ReactNode }) {
  return (
    <svg
      width={taille}
      height={taille}
      viewBox="0 0 24 24"
      fill="none"
      stroke={couleur}
      strokeWidth={epaisseur}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      {enfants}
    </svg>
  );
}

export const Micro = (p: PropsIcone) => (
  <Trace
    {...p}
    enfants={
      <>
        <rect x="9" y="3" width="6" height="11" rx="3" />
        <path d="M5.5 11.5a6.5 6.5 0 0 0 13 0" />
        <path d="M12 18v3" />
      </>
    }
  />
);

export const Horloge = (p: PropsIcone) => (
  <Trace
    {...p}
    enfants={
      <>
        <circle cx="12" cy="12" r="9" />
        <path d="M12 7v5l3 2" />
      </>
    }
  />
);

export const Alerte = (p: PropsIcone) => (
  <Trace
    {...p}
    enfants={
      <>
        <path d="M12 3 2.5 20h19L12 3z" />
        <path d="M12 10v4" />
        <path d="M12 17.2v.3" />
      </>
    }
  />
);

export const Famille = (p: PropsIcone) => (
  <Trace
    {...p}
    enfants={
      <>
        <circle cx="9" cy="8" r="3.2" />
        <path d="M3.5 19c.6-3 2.8-4.6 5.5-4.6s4.9 1.6 5.5 4.6" />
        <circle cx="17" cy="9.5" r="2.4" />
        <path d="M14.8 19c.4-2.2 1.6-3.4 3.4-3.6" />
      </>
    }
  />
);

export const Panier = (p: PropsIcone) => (
  <Trace
    {...p}
    enfants={
      <>
        <path d="M3 4h2l2.6 11.4a1.6 1.6 0 0 0 1.6 1.3h7.9a1.6 1.6 0 0 0 1.6-1.2L20.5 8H6" />
        <circle cx="10" cy="20" r="1.4" />
        <circle cx="17" cy="20" r="1.4" />
      </>
    }
  />
);

export const Enveloppe = (p: PropsIcone) => (
  <Trace
    {...p}
    enfants={
      <>
        <rect x="3" y="5" width="18" height="14" rx="2" />
        <path d="m3.5 6.5 8.5 6 8.5-6" />
      </>
    }
  />
);

export const Coche = (p: PropsIcone) => <Trace {...p} enfants={<path d="m4.5 12.5 5 5 10-11" />} />;

export const ChevronGauche = (p: PropsIcone) => (
  <Trace {...p} enfants={<path d="m14.5 6-6 6 6 6" />} />
);

export const ChevronDroite = (p: PropsIcone) => (
  <Trace {...p} enfants={<path d="m9.5 6 6 6-6 6" />} />
);

/** Le chevron vers le bas : il pivote de 180° quand ce qu'il ouvre est deplie. */
export const ChevronBas = (p: PropsIcone) => (
  <Trace {...p} enfants={<path d="m6 9 6 6 6-6" />} />
);

/** Ce qui est prive : porte sur une pilule d'evenement. */
export const Cadenas = (p: PropsIcone) => (
  <Trace
    {...p}
    enfants={
      <>
        <rect x="5" y="11" width="14" height="9" rx="2" />
        <path d="M8.5 11V8a3.5 3.5 0 0 1 7 0v3" />
      </>
    }
  />
);

/** L'etoile des gestes qui APPELLENT l'IA — donc ceux qui coutent. */
export const Etoile = (p: PropsIcone) => (
  <Trace {...p} enfants={<path d="M12 3.5 14 9l5.5 2-5.5 2-2 5.5-2-5.5L4.5 11 10 9z" />} />
);

export const Cloche = (p: PropsIcone) => (
  <Trace
    {...p}
    enfants={
      <>
        <path d="M18 9a6 6 0 0 0-12 0c0 5-2 6-2 6h16s-2-1-2-6" />
        <path d="M10.3 19a2 2 0 0 0 3.4 0" />
      </>
    }
  />
);

export const Cadeau = (p: PropsIcone) => (
  <Trace
    {...p}
    enfants={
      <>
        <rect x="4" y="8.5" width="16" height="4" rx="1" />
        <path d="M5.5 12.5V19a1.5 1.5 0 0 0 1.5 1.5h10a1.5 1.5 0 0 0 1.5-1.5v-6.5" />
        <path d="M12 8.5v12" />
        <path d="M12 8.5s-4.5.3-5.5-1.7C5.6 5 7.5 3.6 9 4.4c1.9 1 3 4.1 3 4.1" />
        <path d="M12 8.5s4.5.3 5.5-1.7C18.4 5 16.5 3.6 15 4.4c-1.9 1-3 4.1-3 4.1" />
      </>
    }
  />
);

export const Telecharger = (p: PropsIcone) => (
  <Trace
    {...p}
    enfants={
      <>
        <path d="M12 3v12" />
        <path d="m7 10 5 5 5-5" />
        <path d="M4 19h16" />
      </>
    }
  />
);

export const CalendrierCoche = (p: PropsIcone) => (
  <Trace
    {...p}
    enfants={
      <>
        <rect x="4" y="6" width="16" height="14" rx="2" />
        <path d="M8 4v4M16 4v4" />
        <path d="m8.5 14 2.5 2.5 4.5-5" />
      </>
    }
  />
);

// --- Icones de la barre de navigation ---

export const NavAujourdhui = (p: PropsIcone) => (
  <Trace
    {...p}
    enfants={
      <>
        <circle cx="12" cy="12" r="4" />
        <path d="M12 3v2M12 19v2M3 12h2M19 12h2M5.6 5.6l1.4 1.4M17 17l1.4 1.4M18.4 5.6 17 7M7 17l-1.4 1.4" />
      </>
    }
  />
);

export const NavBoite = (p: PropsIcone) => (
  <Trace
    {...p}
    enfants={
      <>
        <path d="M3 12v5a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-5" />
        <path d="M3 12 5.5 5.8A1.4 1.4 0 0 1 6.8 5h10.4a1.4 1.4 0 0 1 1.3.8L21 12" />
        <path d="M3 12h5.2a3.8 3.8 0 0 0 7.6 0H21" />
      </>
    }
  />
);

export const NavPlanning = (p: PropsIcone) => (
  <Trace
    {...p}
    enfants={
      <>
        <rect x="3.5" y="5" width="17" height="16" rx="2.5" />
        <path d="M8 3v4M16 3v4M3.5 10h17" />
      </>
    }
  />
);

export const NavColette = (p: PropsIcone) => (
  <Trace
    {...p}
    enfants={
      <>
        <circle cx="12" cy="8.5" r="3.6" />
        <path d="M4.5 20.5c1-4 3.9-6 7.5-6s6.5 2 7.5 6" />
      </>
    }
  />
);
